import { render, staticRenderFns } from "./SelfAssign.vue?vue&type=template&id=5384b726"
import script from "./SelfAssign.vue?vue&type=script&lang=js"
export * from "./SelfAssign.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports